<template>
    <span v-if="logo" class="c-a-avatar c-a-avatar--with-logo">
        <img class="c-a-avatar__logo" :src="logo.src" :alt="logo.alt">
        <span class="c-a-avatar__bg-logo" :style="`background-image: url(${logo.src})`"></span>
    </span>
    <span v-else-if="signature" class="c-a-avatar">
        <span>{{initial}}</span>
    </span>
    <span v-else class="c-a-avatar">
        <icon :icon="avatarIcon" class="c-a-avatar__icon"></icon>
    </span>
</template>

<script>
    import Icon from './AtomIcon.vue';

    export default {
        components: {
            Icon
        },
        props: {
            signature: String,
            logo: Object,
            icon: String
        },
        computed: {
            initial: function() {
                return this.signature.slice(0, 1).toUpperCase()
            },
            avatarIcon: function() {
                return this.icon ? this.icon : 'person'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomAvatar.vue